export const ru = {
    document_add: 'Добавить документ',
    empty_description: 'Они нужны для покупки билетов и брони отелей',
    empty_title: 'Добавьте документы',
    expires_date: 'Действует до {date}',
    expired_message: 'Истёк срок действия',
    document_type: 'Тип документа',
    confirm_remove_title: 'Удалить документ?',
};
